import { BannersFiltersType } from '@components/marketing/banners/grid/BannersFilter'
import { makeBetweenFilter, makeFilter } from './crud/filters'
import { CommonStatusUILabel } from '@@partner:types:app'
import { BANNER } from '@hive/status'

export const prepareBannersFilter = (filters: BannersFiltersType) => {
  const nameFilter = makeFilter('name', 'includes', filters.name)
  const typeIdsFilter = makeFilter('typeIds', 'contains', filters.typeIds)
  const statusFilter = makeFilter('status', 'contains', filters.statuses)
  const activeFromFilter = makeBetweenFilter('activeFrom', filters.activeFrom)
  const activeUntilFilter = makeBetweenFilter('activeUntil', filters.activeUntil)
  
  return {
    and: [
      nameFilter,
      typeIdsFilter,
      statusFilter,
      activeFromFilter,
      activeUntilFilter
    ]
  }
}
interface ProductStatusUISettings extends CommonStatusUILabel {
  value: number
}

export function getSearchableBannersStatuses (): ProductStatusUISettings[] {
  return [
    {
      label: 'Активен',
      value: BANNER.ENABLED,
      color: 'green'
    },
    {
      label: 'Неактивен',
      value: BANNER.DISABLED,
      color: 'red'
    }
  ]
}


